import autoAnimate from '@formkit/auto-animate'
import {
  FunctionComponent,
  RefObject,
  useEffect,
  useRef,
  useState
} from 'react'
import ProjectUpdateItem from '../ProjectUpdateItem'
import { useFetch } from '../useFetch'

interface ProjectUpdateListInterface {
  projectID: string
  projectUpdateApi: string
}

const ProjectUpdateList: FunctionComponent<ProjectUpdateListInterface> = ({
  projectID,
  projectUpdateApi
}) => {
  const { data, error, fetchWorker, loading } = useFetch()
  const [page, setPage] = useState(5)
  useEffect(() => {
    fetchWorker({ url: `${projectUpdateApi}${projectID}` })
  }, [projectUpdateApi])

  const parent = useRef<HTMLUListElement>(null)
  const loadMore = () => {
    setPage((page) => page + 5)
  }
  useEffect(() => {
    parent.current && autoAnimate(parent.current)
  }, [parent])

  return (
    <>
      <ul
        className="news-search-results__list list-none pl-0"
        ref={parent as RefObject<HTMLUListElement>}
      >
        {loading ||
          (!data && (
            <>
              <li className="news-search-results__item list-none">
                <ProjectUpdateItem
                  isLoading={true}
                  projectUpdateDate={''}
                  projectUpdateImgLarge={''}
                  projectUpdateImgAltTagLarge={''}
                  projectUpdateImgThumbnail={''}
                  projectUpdateImgAltTagThumbnail={''}
                  projectUpdateContent={''}
                  projectUpdateTitle={''}
                />
              </li>
              <li className="news-search-results__item">
                <ProjectUpdateItem
                  isLoading={true}
                  projectUpdateDate={''}
                  projectUpdateImgLarge={''}
                  projectUpdateImgAltTagLarge={''}
                  projectUpdateImgThumbnail={''}
                  projectUpdateImgAltTagThumbnail={''}
                  projectUpdateContent={''}
                  projectUpdateTitle={''}
                />
              </li>
              <li className="news-search-results__item">
                <ProjectUpdateItem
                  isLoading={true}
                  projectUpdateDate={''}
                  projectUpdateImgLarge={''}
                  projectUpdateImgAltTagLarge={''}
                  projectUpdateImgThumbnail={''}
                  projectUpdateImgAltTagThumbnail={''}
                  projectUpdateContent={''}
                  projectUpdateTitle={''}
                />
              </li>
              <li className="news-search-results__item">
                <ProjectUpdateItem
                  isLoading={true}
                  projectUpdateDate={''}
                  projectUpdateImgLarge={''}
                  projectUpdateImgAltTagLarge={''}
                  projectUpdateImgThumbnail={''}
                  projectUpdateImgAltTagThumbnail={''}
                  projectUpdateContent={''}
                  projectUpdateTitle={''}
                />
              </li>
              <li className="news-search-results__item">
                <ProjectUpdateItem
                  isLoading={true}
                  projectUpdateDate={''}
                  projectUpdateImgLarge={''}
                  projectUpdateImgAltTagLarge={''}
                  projectUpdateImgThumbnail={''}
                  projectUpdateImgAltTagThumbnail={''}
                  projectUpdateContent={''}
                  projectUpdateTitle={''}
                />
              </li>
            </>
          ))}
        {error && (
          <li className="list-none">
            <p>...error</p>
          </li>
        )}
        {data
          ?.map((proj) => (
            <li
              key={proj.projectUpdateIndex}
              className="news-search-results__item"
            >
              <ProjectUpdateItem {...proj} />
            </li>
          ))
          .slice(0, page)}
      </ul>
      {page < (data?.length ?? 0) && (
        <div className="w-auto" style={{ backgroundColor: 'white' }}>
          <button className="btn-secondary btn-mobile" onClick={loadMore}>
            Load more
          </button>
        </div>
      )}
    </>
  )
}

export default ProjectUpdateList
